import * as constants from './constants'
import { get } from 'request'
import { getLoginInfo } from 'request/account'
import { message } from 'antd'

export const setMenuCollapsed = () => ({ type: constants.MENU_COLLAPSED })
export const setLoginStatus = value => ({ type: constants.CHANGE_LOGIN_STATUS, value })
export const setBreadcrumb = value => ({ type: constants.SET_BREADCRUMB, value })

export const getEventTypes = () => {
  return dispatch => {
    get('/home/eventTypes').then(res => {
      if (res.success) {
        dispatch({ type: constants.SET_EVENT_TYPES, value: res.data })
      } else {
        message.error('获取事件类型失败')
      }
    })
  }
}

export const getUserInfo = () => {
  return dispatch => {
    getLoginInfo().then(res => {
      if (res.success) {
        dispatch({ type: constants.SET_LOGIN_USER, value: res.data })
      }
    })
  }
}

export const getVillageList = () => {
  return dispatch => {
    get('/home/villages').then(res => {
      if (res.success) {
        dispatch({ type: constants.SET_VILLAGE_LIST, value: res.data })
      } else {
        message.error('获取村庄失败')
      }
    })
  }
}
